document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-header]');
  const onScroll = () => header?.classList.toggle('scrolled', scrollY > 24);
  onScroll(); addEventListener('scroll', onScroll, { passive: true });

  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting) { entry.target.classList.add('visible'); observer.unobserve(entry.target); }
  }), { threshold: .13 });
  document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

  document.querySelectorAll('[data-image]').forEach(btn => btn.addEventListener('click', () => {
    const gallery = btn.closest('.product-gallery');
    const main = gallery?.querySelector('[data-gallery-main]');
    if (main) { main.style.opacity = '0'; setTimeout(() => { main.src = btn.dataset.image; main.style.opacity = '1'; }, 180); }
    gallery?.querySelectorAll('[data-image]').forEach(x => x.classList.remove('active')); btn.classList.add('active');
  }));

  document.querySelectorAll('.finish').forEach(btn => btn.addEventListener('click', () => {
    const section = btn.closest('.product-showcase');
    section?.querySelectorAll('.finish').forEach(x => x.classList.remove('active')); btn.classList.add('active');
    const label = section?.querySelector('[data-finish-label]'); if (label) label.textContent = btn.dataset.finish;
    const main = section?.querySelector('[data-gallery-main]');
    if (main && btn.dataset.image) { main.style.opacity = '0'; setTimeout(() => { main.src = btn.dataset.image; main.alt = `FireFuser in ${btn.dataset.finish}`; main.style.opacity = '1'; }, 150); }
  }));

  document.querySelectorAll('.swatches button').forEach(btn => btn.addEventListener('click', () => {
    const card = btn.closest('.spectrum-card');
    card?.querySelectorAll('.swatches button').forEach(x => x.classList.remove('active')); btn.classList.add('active');
    const label = card?.querySelector('.spectrum-overlay > span'); if (label) label.textContent = btn.ariaLabel.toUpperCase();
    const image = card?.querySelector('[data-spectrum-image]');
    if (image && btn.dataset.image) { image.style.opacity = '0'; setTimeout(() => { image.src = btn.dataset.image; image.alt = `FireFuser glowing in ${btn.ariaLabel.toLowerCase()} ambient mode`; image.style.opacity = '1'; }, 150); }
  }));

  document.querySelectorAll('[data-qty-minus],[data-qty-plus]').forEach(btn => btn.addEventListener('click', () => {
    const input = btn.parentElement.querySelector('input'); const n = Number(input.value) || 1;
    input.value = btn.hasAttribute('data-qty-plus') ? n + 1 : Math.max(1, n - 1);
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }));

  document.querySelectorAll('[data-product-root]').forEach(root => {
    const data = root.querySelector('[data-product-variants]');
    if (!data) return;
    const variants = JSON.parse(data.textContent);
    const selects = [...root.querySelectorAll('[data-option-position]')];
    const idInput = root.querySelector('input[name="id"]');
    const submit = root.querySelector('.product-form [type="submit"]');
    const price = root.querySelector('.price strong');
    const total = root.querySelector('[data-order-total]');
    const quantity = root.querySelector('input[name="quantity"]');
    const mainImage = root.querySelector('[data-gallery-main]');
    const money = cents => new Intl.NumberFormat('en-US', { style: 'currency', currency: root.dataset.currency || 'USD' }).format(cents / 100);
    let currentVariant;
    const syncPrice = () => {
      if (!currentVariant) return;
      const count = Math.max(1, Number(quantity?.value) || 1);
      const lineTotal = currentVariant.price * count;
      if (price) price.textContent = money(currentVariant.price);
      if (total) total.textContent = money(lineTotal);
      if (submit) { submit.disabled = !currentVariant.available; submit.textContent = currentVariant.available ? `Add to bag — ${money(lineTotal)}` : 'Sold out'; }
    };
    const syncVariant = () => {
      const selected = {};
      selects.forEach(select => selected[Number(select.dataset.optionPosition)] = select.value);
      const variant = variants.find(item => Object.entries(selected).every(([position, value]) => item.options[Number(position)] === value));
      if (!variant) { if (submit) { submit.disabled = true; submit.textContent = 'Unavailable'; } return; }
      currentVariant = variant;
      idInput.value = variant.id;
      syncPrice();
      const color = variant.options.find(value => /black|white|ivory/i.test(value));
      if (mainImage && color) {
        const nextImage = /black/i.test(color) ? root.dataset.blackImage : root.dataset.whiteImage;
        if (nextImage && mainImage.src !== nextImage) { mainImage.style.opacity = '0'; setTimeout(() => { mainImage.src = nextImage; mainImage.alt = `FireFuser in ${color}`; mainImage.style.opacity = '1'; }, 150); }
      }
    };
    selects.forEach(select => select.addEventListener('change', syncVariant));
    quantity?.addEventListener('input', syncPrice);
    syncVariant();
  });

  document.querySelectorAll('[data-ajax-cart]').forEach(form => form.addEventListener('submit', async e => {
    e.preventDefault(); const button = form.querySelector('[type=submit]'); const old = button.textContent; button.textContent = 'Adding…';
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error();
      button.textContent = 'Opening your bag…';
      window.location.assign('/cart');
    } catch {
      const redirect = document.createElement('input'); redirect.type = 'hidden'; redirect.name = 'return_to'; redirect.value = '/cart'; form.appendChild(redirect); form.submit();
    }
  }));

  document.querySelectorAll('[data-buy-now]').forEach(button => button.addEventListener('click', () => {
    const form = button.closest('form'); const input = document.createElement('input'); input.type = 'hidden'; input.name = 'return_to'; input.value = '/checkout'; form.appendChild(input); form.submit();
  }));
});
